import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { NavItem, NavLink, TabContent } from 'reactstrap';

import { useTranslation } from 'react-i18next';
import { useFetchProfile } from '../../api-hooks/profile/me';
import { ModalLazyContent } from '../Modal/LazyContent';
import { ModalScreenHeader, ModalScreenHeaderNav } from '../Modal/Screen/Header';
import { ModalScreen } from '../Modal/Screen/Screen';
import { MyAccountModalTab, useUserSettings } from './Context';
import { ProfileRewardNotice } from './ProfileRewardNotice';

const MyAccountModalContent = lazy(() => import('./MyAccountModalContent'));

export const MyAccountModal = ({ isOpen, activeTab, setActiveTab }) => {
	const { t } = useTranslation();
	const { closeModal } = useUserSettings();
	const { data: profile } = useFetchProfile();

	return (
		<ModalScreen
			bodyClassName="py-0"
			header={(
				<ModalScreenHeader
					onClose={closeModal}
					title={t('UserSettings.MyAccountModal.myAccount')}
					notice={!profile?.completedRewardClaimed ? <ProfileRewardNotice /> : undefined}
				>
					<ModalScreenHeaderNav className="mt-3">
						<NavItem className="mr-3">
							<NavLink
								title="Details"
								onClick={() => setActiveTab(MyAccountModalTab.DETAILS)}
								active={activeTab === MyAccountModalTab.DETAILS}
							>
								<span>{t('UserSettings.MyAccountModal.details')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="mr-3">
							<NavLink
								title="Settings"
								onClick={() => setActiveTab(MyAccountModalTab.SETTINGS)}
								active={activeTab === MyAccountModalTab.SETTINGS}
							>
								<span>{t('UserSettings.MyAccountModal.settings')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="ml-3">
							<NavLink
								title={t('UserSettings.MyAccountModal.operators')}
								onClick={() => setActiveTab(MyAccountModalTab.OPERATORS)}
								active={activeTab === MyAccountModalTab.OPERATORS}
							>
								<span>{t('UserSettings.MyAccountModal.operators')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="ml-3">
							<NavLink
								title={t('UserSettings.MyAccountModal.qrcode')}
								onClick={() => setActiveTab(MyAccountModalTab.QRCODE)}
								active={activeTab === MyAccountModalTab.QRCODE}
							>
								<span>{t('UserSettings.MyAccountModal.qrcodeMaj')}</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
						<NavItem className="ml-3">
							<NavLink
								title="Notifications"
								onClick={() => setActiveTab(MyAccountModalTab.NOTIFICATIONS)}
								active={activeTab === MyAccountModalTab.NOTIFICATIONS}
							>
								<span>Notifications</span>
								<div className="divider" />
							</NavLink>
						</NavItem>
					</ModalScreenHeaderNav>
				</ModalScreenHeader>
			)}
			isOpen={isOpen}
			onClose={closeModal}
		>
			<TabContent activeTab={activeTab}>
				<ModalLazyContent>
					<MyAccountModalContent activeTab={activeTab} />
				</ModalLazyContent>
			</TabContent>
		</ModalScreen>
	);
};

MyAccountModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	activeTab: PropTypes.oneOf(Object.values(MyAccountModalTab)),
	setActiveTab: PropTypes.func,
};

MyAccountModal.defaultProps = {
	activeTab: MyAccountModalTab.DETAILS,
	setActiveTab: PropTypes.func,
};
